import React from 'react';
import StepperTabs from '../../../../../components/StepperTabs/StepperTabs';
import StepTab from '../../../../../components/StepperTabs/StepTab';
import Step1Details from '../EnrollmentSteps/Step1Details';
import Step2OtherDetails from '../EnrollmentSteps/Step2OtherDetails';
import Step3EmployeeContract from '../EnrollmentSteps/Step3EmployeeContract';
import CustomPhotoPicker from '../../../../../components/PhotoPicker/CustomPhotoPicker';
import Step7Card from '../EnrollmentSteps/Step7Card';
import DocumentTable from '../../../../Modals/DocumentTable';
import Step9DrivingPermits from '../EnrollmentSteps/Step9DrivingPermits';
import AccessRights from '../AccessRightsSection/AccessRights';
import FingerprintStep from '../EnrollmentSteps/FingerprintStep';
import { SUGGESTION_MODE_OPTION } from '../../../../../components/PhotoPicker/SubComponent/Models/Models';
import { ACTION_MODEL } from '../../../../../Helpers/ActionModel';
import { FILE_TYPE } from '../../../../../Helpers/fileType';
import { UPDATE_EMPLOYEE_WITH_EXTRA_DATA } from '../Model/Models';

/**
 * @Email : sgarcia@ibl.mx
 * @Author: Susana Garcia Rodriguez
 * @jobTittle: Frontend
 */
const UpdateEmployeeWithExtraData = (props) => {
    const {
        id,
        disabled,
        steps,
        activeStep,
        setActiveStep,
        handleStepChange,
        userData,
        handleFormChangeUserData,
        emptyFields,
        isValidPhoneNumber,
        isValidDocumentId,
        isValidDob,
        setIsValidDob,
        isValidPin,
        isValidEmail,
        extraData,
        handleFormChangeExtraData,
        setExtraData,
        headersList,
        employeeData,
        employeeRoles,
        employeeWorkStations,
        contractStatusList,
        employeeDepartments,
        isValidStartDate,
        setIsValidStartDate,
        isValidEndDate,
        setIsValidEndDate,
        handleFormChangeEmployeeData,
        setEmployeeData,
        isPilgrimsValidation,
        permission,
        permissionObj,
        photoPickerFile,
        setPhotoPickerFile,
        emptySelfie,
        handleDeleteImage,
        cardsList,
        setCardsList,
        documentsList,
        updated,
        setUpdated,
        vehicleData,
        selectVehicleForDelete,
        handleCheckboxChangeVehicle,
        isAllChecked,
        handleDeleteAll,
        setDeletePermitShow,
        workShiftsList,
        setWorkShiftsList,
        customizedList,
        setCustomizedList,
        resetForm,
        t,
        capturing,
        setCapturing,
        capturedFingerprint,
        setCapturedFingerprint,
        fingerprintSrc,
        setFingerprintSrc,
        updatedFinger,
        setFingerprintName,
        setSelectedReader,
        fingerprintsList,
        setModified,
        fingerprintName,
        handleUploadFinger,
        setEmptyFields,
        fingerprintsTemp,
        setFingerprintsTemp,
        mergedFingerprints,
        DEV,
        isValidCecoCode
    } = props;
    return (
        <>
            <StepperTabs
                id={id}
                disabled={disabled}
                steps={steps}
                activeStep={activeStep}
                isStepOptional={() => {}}
                setActiveStep={setActiveStep}
                handleStepChange={handleStepChange}
            >
                <StepTab index={UPDATE_EMPLOYEE_WITH_EXTRA_DATA.DETAILS} activeStep={activeStep} normalHeight={true}>
                    <Step1Details
                        userData={userData}
                        onChange={handleFormChangeUserData}
                        emptyFields={emptyFields}
                        isValidPhoneNumber={isValidPhoneNumber}
                        isValidDocumentId={isValidDocumentId}
                        isValidDob={isValidDob}
                        setIsValidDob={setIsValidDob}
                        isValidPin={isValidPin}
                        isValidEmail={isValidEmail}
                    />
                </StepTab>
                <StepTab
                    index={UPDATE_EMPLOYEE_WITH_EXTRA_DATA.OTHER_DETAILS}
                    activeStep={activeStep}
                    normalHeight={true}
                >
                    <Step2OtherDetails
                        showBtnClean={userData?.id == null || userData?.id == ''}
                        extraData={extraData}
                        onChange={handleFormChangeExtraData}
                        setExtraData={setExtraData}
                        headersList={headersList}
                    />
                </StepTab>
                <StepTab
                    index={UPDATE_EMPLOYEE_WITH_EXTRA_DATA.EMPLOYEE_CONTRACT}
                    activeStep={activeStep}
                    normalHeight={true}
                >
                    <Step3EmployeeContract
                        employeeData={employeeData}
                        employeeRoles={employeeRoles}
                        employeeWorkStations={employeeWorkStations}
                        contractStatusList={contractStatusList}
                        employeeDepartments={employeeDepartments}
                        emptyFields={emptyFields}
                        isValidStartDate={isValidStartDate}
                        setIsValidStartDate={setIsValidStartDate}
                        isValidEndDate={isValidEndDate}
                        setIsValidEndDate={setIsValidEndDate}
                        onChange={handleFormChangeEmployeeData}
                        setEmployeeData={setEmployeeData}
                        isPilgrimsValidation={isPilgrimsValidation}
                        isValidCecoCode
                    />
                </StepTab>
                <StepTab
                    index={UPDATE_EMPLOYEE_WITH_EXTRA_DATA.PHOTO_PROFILE}
                    activeStep={activeStep}
                    normalHeight={true}
                >
                    {(DEV || permission?.includes(permissionObj?.WEB_EMPLOYEE_UPDATE)) && (
                        <CustomPhotoPicker
                            id='fp_uewed_update_photo_profile'
                            photoPicker={photoPickerFile}
                            setPhotoPicker={setPhotoPickerFile}
                            actionModel={ACTION_MODEL.UPDATE}
                            accept={{ ...FILE_TYPE.IMAGE_FACE_VALIDATION }}
                            showBtnCamera={true}
                            emptyFields={emptySelfie}
                            required={isPilgrimsValidation}
                            validateFace={true}
                            classWith={'w-400px'}
                            showPreview={true}
                            disabled={disabled}
                            titleModalEdit='update_photography'
                            typeSuggestions={SUGGESTION_MODE_OPTION.SELFIE} // It is required if showBtnCamera is true
                            handleDelete={photoPickerFile?.previewImage ? handleDeleteImage : undefined}
                        />
                    )}
                </StepTab>
                <StepTab index={UPDATE_EMPLOYEE_WITH_EXTRA_DATA.CARD} activeStep={activeStep} normalHeight={true}>
                    {activeStep === UPDATE_EMPLOYEE_WITH_EXTRA_DATA.CARD && (
                        <Step7Card
                            cardsList={cardsList}
                            setCardsList={setCardsList}
                            userData={userData}
                            componentAction= {ACTION_MODEL.UPDATE}
                        />
                    )}
                </StepTab>
                <StepTab
                    index={UPDATE_EMPLOYEE_WITH_EXTRA_DATA.DOCUMENT_TABLE}
                    activeStep={activeStep}
                    normalHeight={true}
                >
                    {activeStep === UPDATE_EMPLOYEE_WITH_EXTRA_DATA.DOCUMENT_TABLE && (
                        <DocumentTable
                            dataTable={documentsList}
                            approve={true}
                            optionDownload='employee_document'
                            employeeName={userData.name || '' + ' ' + userData.lastName || ''}
                            updated={updated}
                            setUpdated={setUpdated}
                        />
                    )}
                </StepTab>
                <StepTab
                    index={UPDATE_EMPLOYEE_WITH_EXTRA_DATA.DRIVING_PERMITS}
                    activeStep={activeStep}
                    normalHeight={true}
                >
                    {activeStep == UPDATE_EMPLOYEE_WITH_EXTRA_DATA.DRIVING_PERMITS && (
                        <Step9DrivingPermits
                            vehicleData={vehicleData}
                            selectVehicleForDelete={selectVehicleForDelete}
                            handleCheckboxChange={handleCheckboxChangeVehicle}
                            isAllChecked={isAllChecked}
                            handleCheckedAll={handleDeleteAll}
                            handleDelete={() => {
                                setDeletePermitShow(true);
                            }}
                        />
                    )}
                </StepTab>
                <StepTab
                    index={UPDATE_EMPLOYEE_WITH_EXTRA_DATA.ACCESS_RIGHTS}
                    activeStep={activeStep}
                    normalHeight={true}
                >
                    <AccessRights
                        workShiftsList={workShiftsList}
                        setWorkShiftsList={setWorkShiftsList}
                        customizedList={customizedList}
                        setCustomizedList={setCustomizedList}
                        user={userData}
                        isEditable={true}
                        resetForm={() => {
                            resetForm(activeStep);
                        }}
                    />
                </StepTab>
                <StepTab
                    index={UPDATE_EMPLOYEE_WITH_EXTRA_DATA.FINGERPRINT}
                    activeStep={activeStep}
                    normalHeight={true}
                >
                    {activeStep == UPDATE_EMPLOYEE_WITH_EXTRA_DATA.FINGERPRINT && (
                        <FingerprintStep
                            t={t}
                            capturing={capturing}
                            setCapturing={setCapturing}
                            capturedFingerprint={capturedFingerprint}
                            setCapturedFingerprint={setCapturedFingerprint}
                            fingerprintSrc={fingerprintSrc}
                            setFingerprintSrc={setFingerprintSrc}
                            updatedFinger={updatedFinger}
                            setFingerprintName={setFingerprintName}
                            setSelectedReader={setSelectedReader}
                            fingerprintsList={fingerprintsList}
                            setUpdated={setUpdated}
                            setModified={setModified}
                            fingerprintName={fingerprintName}
                            handleUploadFinger={handleUploadFinger}
                            setEmptyFields={setEmptyFields}
                            userData={userData}
                            fingerprintsTemp={fingerprintsTemp}
                            setFingerprintsTemp={setFingerprintsTemp}
                            mergedFingerprints={mergedFingerprints}
                            emptyFields={emptyFields}
                        />
                    )}
                </StepTab>
            </StepperTabs>
        </>
    );
};

export default UpdateEmployeeWithExtraData;
